export const translations = {
  fr: {
    // Header
    header: {
      howItWorks: 'Comment ça marche',
      whyItMatters: "Pourquoi c'est important",
      faq: 'FAQ',
      launchCalculator: 'Lancer le calculateur',
    },
    // Hero
    hero: {
      title:
        'Trouvez le moyen le moins cher de payer avec votre carte prépayée',
      subtitle:
        'Comparez le coût réel de vos paiements entre les cartes Djamo et Wave en un seul endroit.',
      cta: 'Comparer maintenant',
      paymentAmount: 'Montant du paiement',
      best: 'MEILLEUR',
    },
    // Calculator
    calculator: {
      title: 'Comparer les coûts de paiement',
      subtitle:
        'Entrez les détails de votre paiement pour voir quel fournisseur offre le meilleur taux',
      amountLabel: 'Montant du paiement',
      currencyLabel: 'Devise',
      compareButton: 'Comparer les fournisseurs',
      currencyEur: 'EUR (Euro)',
      currencyUsd: 'USD (Dollar américain)',
      currencyXof: 'XOF (Franc CFA)',
    },
    // Today's Rates
    todayRates: {
      title: "Taux d'aujourd'hui",
      subtitle: 'Taux de change actuels pour tous les fournisseurs',
      perUnit: 'pour 1',
      bestRate: 'MEILLEUR TAUX',
      updateNotice:
        '✓ Taux mis à jour régulièrement pour vous garantir les meilleurs résultats',
    },
    // Results
    results: {
      title: 'Résultats de la comparaison',
      bestOption: 'MEILLEURE OPTION',
      mostAffordable: 'Le plus abordable',
      totalCost: 'Coût total',
      conversionRate: 'Taux de conversion',
      totalCharge: 'Montant facturé',
      fxRate: 'Taux de change',
      savings: 'Différence',
      fee: 'Frais',
      feeNotSpecified: 'Frais non communiqués',
      note: "Ces calculs utilisent les taux de change actuels. Les coûts réels peuvent varier légèrement. Vérifiez toujours le montant final dans l'application de votre fournisseur avant de confirmer le paiement.",
      filterByCountry: 'Filtrer par pays',
      allCountries: 'Tous les pays',
      senegal: 'Sénégal',
      coteDivoire: "Côte d'Ivoire",
      updateNotice:
        '✓ Taux mis à jour régulièrement pour vous garantir les meilleurs résultats',
      openInApp: "Ouvrir dans l'app",
    },
    // How It Works
    howItWorks: {
      title: 'Comment ça marche',
      subtitle:
        'Trois étapes simples pour trouver la meilleure option de paiement',
      step1Title: 'Entrez le montant et la devise',
      step1Desc:
        'Dites-nous combien vous voulez payer et dans quelle devise (EUR, USD ou XOF).',
      step2Title: 'Nous appliquons les règles de chaque fournisseur',
      step2Desc:
        'Nous calculons le coût réel en utilisant les taux de change et structures de frais de chaque fournisseur.',
      step3Title: 'Voyez quelle carte est la moins chère',
      step3Desc:
        "Obtenez des résultats instantanés montrant quelle carte prépayée vous fait économiser le plus d'argent.",
    },
    // Why It Matters
    whyItMatters: {
      title: "Pourquoi c'est important",
      subtitle:
        'Comprendre les coûts de paiement vous aide à prendre des décisions financières plus intelligentes',
      reason1Title: 'Taux différents, coûts différents',
      reason1Desc:
        "Djamo et Wave utilisent des taux de change différents. Les petites différences s'accumulent pour des économies significatives au fil du temps.",
      reason2Title: "Conçu pour l'Afrique de l'Ouest",
      reason2Desc:
        "Conçu spécifiquement pour les pays de l'UEMOA et la devise XOF. Nous comprenons le paysage fintech local.",
      reason3Title: 'Économisez des milliers de XOF',
      reason3Desc:
        'Faire des choix éclairés sur chaque paiement peut vous faire économiser des milliers de francs chaque mois. Chaque paiement compte.',
    },
    // FAQ
    faq: {
      title: 'Questions fréquemment posées',
      subtitle: 'Tout ce que vous devez savoir sur AfriCard Compare',
      q1: 'Ces chiffres sont-ils exacts ?',
      a1: "Ces calculs utilisent des taux et structures de frais estimés basés sur des informations publiques. Les coûts réels peuvent varier légèrement en fonction des taux de change actuels et des politiques des fournisseurs. Vérifiez toujours le montant final dans l'application de votre fournisseur avant de confirmer tout paiement.",
      q2: 'Quels pays sont pris en charge ?',
      a2: "AfriCard Compare est conçu pour les pays d'Afrique de l'Ouest dans la zone UEMOA qui utilisent le XOF (franc CFA ouest-africain), notamment le Sénégal, la Côte d'Ivoire, le Mali, le Burkina Faso, le Bénin, le Togo, le Niger et la Guinée-Bissau.",
      q3: 'Stockez-vous mes données de carte ?',
      a3: "Non. Nous ne demandons ni ne stockons jamais d'informations sensibles comme les numéros de carte, les codes CVV ou les détails bancaires personnels. Nous utilisons uniquement le montant du paiement et la devise que vous entrez pour calculer les résultats de comparaison. Vos données ne quittent jamais votre navigateur.",
      q4: 'À quelle fréquence les taux sont-ils mis à jour ?',
      a4: "Nous visons à mettre à jour régulièrement nos estimations de taux pour refléter les conditions actuelles du marché. Cependant, les taux en temps réel peuvent différer. Pour les informations les plus précises, vérifiez toujours l'application de votre fournisseur avant d'effectuer un paiement.",
      q5: 'Ce service est-il gratuit ?',
      a5: 'Oui, AfriCard Compare est entièrement gratuit. Nous ne facturons aucun frais et nous ne sommes affiliés à aucun des fournisseurs de paiement. Notre objectif est de vous aider à prendre des décisions éclairées concernant vos paiements."',
    },
    // Footer
    footer: {
      description:
        'Aider les Ouest-Africains à prendre des décisions de paiement plus intelligentes en comparant les coûts des cartes prépayées entre Djamo et Wave.',
      legal: 'Légal',
      terms: "Conditions d'utilisation",
      privacy: 'Politique de confidentialité',
      connect: 'Connexion',
      copyright: 'Tous droits réservés.',
      disclaimer:
        'Non affilié à Djamo ou Wave. Les taux sont des estimations à des fins de comparaison uniquement.',
    },
  },
  en: {
    // Header
    header: {
      howItWorks: 'How it works',
      whyItMatters: 'Why it matters',
      faq: 'FAQ',
      launchCalculator: 'Launch calculator',
    },
    // Hero
    hero: {
      title: 'Find the cheapest way to pay with your prepaid card',
      subtitle:
        'Compare the real cost of your payments across Djamo and Wave cards in one place.',
      cta: 'Compare now',
      paymentAmount: 'Payment amount',
      best: 'BEST',
    },
    // Calculator
    calculator: {
      title: 'Compare payment costs',
      subtitle:
        'Enter your payment details to see which provider offers the best rate',
      amountLabel: 'Payment amount',
      currencyLabel: 'Currency',
      compareButton: 'Compare providers',
      currencyEur: 'EUR (Euro)',
      currencyUsd: 'USD (US Dollar)',
      currencyXof: 'XOF (West African CFA)',
    },
    // Today's Rates
    todayRates: {
      title: "Today's Rates",
      subtitle: 'Current exchange rates across all providers',
      perUnit: 'per 1',
      bestRate: 'BEST RATE',
      updateNotice: '✓ Rates updated regularly to give you the best results',
    },
    // Results
    results: {
      title: 'Comparison results',
      bestOption: 'BEST OPTION',
      mostAffordable: 'Most affordable',
      totalCost: 'Total cost',
      conversionRate: 'Conversion rate',
      totalCharge: 'Total charge',
      fxRate: 'FX Rate',
      savings: 'Difference',
      fee: 'Fee',
      feeNotSpecified: 'Fees not disclosed',
      note: "These calculations use current exchange rates. Actual costs may vary slightly. Always verify the final amount in your provider's app before confirming payment.",
      filterByCountry: 'Filter by country',
      allCountries: 'All countries',
      senegal: 'Senegal',
      coteDivoire: 'Ivory Coast',
      updateNotice: '✓ Rates updated regularly to give you the best results',
      openInApp: 'Open in app',
    },
    // How It Works
    howItWorks: {
      title: 'How it works',
      subtitle: 'Three simple steps to find the best payment option',
      step1Title: 'Enter amount and currency',
      step1Desc:
        'Tell us how much you want to pay and in which currency (EUR, USD, or XOF).',
      step2Title: "We apply each provider's rules",
      step2Desc:
        "We calculate the real cost using each provider's FX rates and fee structures.",
      step3Title: 'See which card is cheapest',
      step3Desc:
        'Get instant results showing which prepaid card saves you the most money.',
    },
    // Why It Matters
    whyItMatters: {
      title: 'Why it matters',
      subtitle:
        'Understanding payment costs helps you make smarter financial decisions',
      reason1Title: 'Different rates, different costs',
      reason1Desc:
        'Djamo and Wave use different FX rates. Small differences add up to significant savings over time.',
      reason2Title: 'Built for West Africa',
      reason2Desc:
        'Designed specifically for UEMOA countries and XOF currency. We understand the local fintech landscape.',
      reason3Title: 'Save thousands of XOF',
      reason3Desc:
        'Making informed choices on every payment can save you thousands of francs each month. Every payment counts.',
    },
    // FAQ
    faq: {
      title: 'Frequently asked questions',
      subtitle: 'Everything you need to know about AfriCard Compare',
      q1: 'Are these numbers exact?',
      a1: "These calculations use estimated rates and fee structures based on publicly available information. Actual costs may vary slightly depending on current exchange rates and provider policies. Always verify the final amount in your provider's app before confirming any payment.",
      q2: 'Which countries are supported?',
      a2: "AfriCard Compare is designed for West African countries in the UEMOA zone that use XOF (West African CFA franc), including Senegal, Côte d'Ivoire, Mali, Burkina Faso, Benin, Togo, Niger, and Guinea-Bissau.",
      q3: 'Do you store my card data?',
      a3: 'No. We never ask for or store any sensitive information like card numbers, CVV codes, or personal banking details. We only use the payment amount and currency you enter to calculate comparison results. Your data never leaves your browser.',
      q4: 'How often are rates updated?',
      a4: "We aim to update our rate estimates regularly to reflect current market conditions. However, real-time rates may differ. For the most accurate information, always check your provider's app before making a payment.",
      q5: 'Is this service free?',
      a5: "Yes, AfriCard Compare is completely free to use. We don't charge any fees and we're not affiliated with any of the payment providers. Our goal is to help you make informed decisions about your payments.",
    },
    // Footer
    footer: {
      description:
        'Helping West Africans make smarter payment decisions by comparing prepaid card costs across Djamo and Wave.',
      legal: 'Legal',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      connect: 'Connect',
      copyright: 'All rights reserved.',
      disclaimer:
        'Not affiliated with Djamo or Wave. Rates are estimates for comparison purposes only.',
    },
  },
}

export type TranslationKey = keyof typeof translations.fr
